import { environment } from 'environment/environment';
import { MenuIdentifiers } from '../../core/services/navigation.service';
import { HubConfig } from '../types/hub-notifications.types';
import { SignalRGroups } from './signalr-groups.const';

export const availableHubConfigs: HubConfig[] = [
  {
    key: SignalRGroups.Tasks.Key,
    url: environment.taskMessagesWSBaseUrl,
    inboundMethod: SignalRGroups.Tasks.NewMessage,
    autoJoinRooms: [SignalRGroups.Tasks.Group],
    menuIdentifier: MenuIdentifiers.YARD_OPERATIONS,
  },
  {
    key: SignalRGroups.Sites.Key,
    url: environment.siteTasksWSBaseUrl,
    inboundMethod: SignalRGroups.Sites.NewMessage,
    autoJoinRooms: [SignalRGroups.Sites.Group],
    menuIdentifier: MenuIdentifiers.YARD_OPERATIONS,
  },
  {
    key: SignalRGroups.Doors.Key,
    url: environment.doorsWSBaseUrl,
    inboundMethod: SignalRGroups.Doors.NewMessage,
    autoJoinRooms: [SignalRGroups.Doors.Group],
    menuIdentifier: MenuIdentifiers.YARD_OPERATIONS_DOCK_ACTIVITY,
  },
  {
    key: SignalRGroups.Trailers.Key,
    url: environment.trailersWSBaseUrl,
    inboundMethod: SignalRGroups.Trailers.NewMessage,
    autoJoinRooms: [SignalRGroups.Trailers.Group],
    menuIdentifier: MenuIdentifiers.YARD_CONTROL,
  },
];

export const availableHubConfigsYO: HubConfig[] = [
  {
    key: SignalRGroups.Tasks.Key,
    url: environment.taskMessagesWSBaseUrlYO,
    inboundMethod: SignalRGroups.Tasks.NewMessage,
    autoJoinRooms: [SignalRGroups.Tasks.Group],
    menuIdentifier: MenuIdentifiers.YARD_OPERATIONS,
  },
  {
    key: SignalRGroups.Sites.Key,
    url: environment.siteTasksWSBaseUrlYO,
    inboundMethod: SignalRGroups.Sites.NewMessage,
    autoJoinRooms: [SignalRGroups.Sites.Group],
    menuIdentifier: MenuIdentifiers.YARD_OPERATIONS,
  },
  {
    key: SignalRGroups.Doors.Key,
    url: environment.doorsWSBaseUrlYO,
    inboundMethod: SignalRGroups.Doors.NewMessage,
    autoJoinRooms: [SignalRGroups.Doors.Group],
    menuIdentifier: MenuIdentifiers.YARD_OPERATIONS_DOCK_ACTIVITY,
  },
  {
    key: SignalRGroups.Trailers.Key,
    url: environment.trailersWsBaseUrlYO,
    inboundMethod: SignalRGroups.Trailers.NewMessage,
    autoJoinRooms: [SignalRGroups.Trailers.GroupYO],
    menuIdentifier: MenuIdentifiers.YARD_CONTROL,
  },
];
